import { CertificadoService } from './../services/certificado.service';
import { Component, OnInit, Input, OnChanges, Inject, OnDestroy } from '@angular/core';
import { HttpUtilService } from './../services/http-util.service';
import { TrocarOutorgaComponent } from '../trocar-outorga/trocar-outorga.component';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OutorgaService } from '../services/outorga.service';
import { Router } from '@angular/router';
import { MANUAL_CNS } from '../app.api';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, OnChanges, OnDestroy{

  certificado;
  isEmpresaOutorgante;
  subscription: Subscription[] = [];
  isCertToken;

  constructor(
    private certificadoService: CertificadoService,
    private httpUtilService: HttpUtilService,
    private outorgaService: OutorgaService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<TrocarOutorgaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.certificado = this.certificadoService.obterDadosCertificadoServlet();
    this.outorgadoSubscribe();
    this.isCertificadoToken();
  }

  convertetoDate(timeStamp: any): string {
    const data = new Date(timeStamp);
    return data.toLocaleDateString('pt-BR');
  }

  ngOnChanges() {
    this.outorgadoSubscribe();
  }

  openDialogTrocarOutorga() {
    this.dialog.open(TrocarOutorgaComponent);
  }

  isPJOuCpfComOutorga() {
    return this.certificado.tpInscricao !== '3' || (this.certificado.tpInscricao ===  '3'  && this.isEmpresaOutorgante);
  }

  outorgadoSubscribe() {
    this.subscription.push(this.outorgaService.getOutorgado()
    .pipe(tap(v => console.log('MENU', v)))
    .subscribe(response => {
      if (response && response[2]) {
          this.isEmpresaOutorgante = response[2];

      }
    }));
  }

  sairOutorga() {
    this.isEmpresaOutorgante = undefined;
    const { tpInscricao, inscricao } = this.httpUtilService.obterDadosCertificado();
   // const outorgado  = tpInscricao + inscricao.padStart(14, 0);
    this.outorgaService.changeOutorgado(null, null, null);
    this.router.navigate(['/home']);
  }

  ngOnDestroy() {
    this.subscription.forEach(s => s.unsubscribe());
  }

  isCertificadoToken(){
    const orgaoTkn: string = this.certificado !== undefined ? this.certificado.issuer.name.split(',')[2].split('=')[1]:undefined;
    this.isCertToken =  orgaoTkn === 'Caixa Economica Federal';
  }

  get urlManual(): string {
    return MANUAL_CNS;
  }

  abrirManual(){
    window.open(this.urlManual.concat('/manual4'), '_blank');
  }
}